var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_3284)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_367_3284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 16H13C12.4 16 12 16.4 12 17V27C12 27.6 12.4 28 13 28H27C27.6 28 28 27.6 28 27V17C28 16.4 27.6 16 27 16ZM23.1 26H16.9C16.5 24.6 15.4 23.5 14 23.1V20.9C15.4 20.5 16.5 19.4 16.9 18H23.2C23.6 19.4 24.7 20.5 26.1 20.9V23.2C24.6 23.5 23.5 24.6 23.1 26Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24C21.1046 24 22 23.1046 22 22C22 20.8954 21.1046 20 20 20C18.8954 20 18 20.8954 18 22C18 23.1046 18.8954 24 20 24Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 12H14V14H26V12Z",
    fill: "#9C82FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_3284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_367_3284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsMoney);
export default __webpack_public_path__ + "static/media/ps-money.d4c06e595f364f02c0a64c7424439f5c.svg";
export { ForwardRef as ReactComponent };